module.exports = __webpack_public_path__ + "static/media/logo.afc0552b.jpg";